import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DataGridProvider } from '@issuemanager/apps/client/components';
import { useSetHeaderProps } from '@issuemanager/apps/client/contexts';
import { IssueTemplateGrid } from './issue-template-grid';
import { ISSUE_TEMPLATES_GRID_KEY } from './constants';

export default function () {
  const { t } = useTranslation(['common', 'settings']);
  const setHeaderProps = useSetHeaderProps();
  useEffect(() => {
    setHeaderProps({
      viewTitle: {
        breadcrumbSections: [{ url: '/', title: t('common:appName') }],
        title: t('settings:routeName'),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={4} py={4}>
      <DataGridProvider storageKey={ISSUE_TEMPLATES_GRID_KEY}>
        <IssueTemplateGrid />
      </DataGridProvider>
    </Box>
  );
}
